/* eslint-disable max-lines-per-function */
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Badge,
  Command,
  CommandItem,
  CommandList,
  CommandSeparator,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui';
import { Mitarbeiter } from '@/domain/termine/shared/types/Mitarbeiter';
import { faUser, faUserGroup } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function MitarbeiterSchichtenPopover({
  mitarbeiterListe,
}: {
  mitarbeiterListe: Mitarbeiter[];
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Badge
          className="flex flex-row items-center gap-1 bg-neutrals-200"
          variant="secondary"
          type={'pill'}>
          <FontAwesomeIcon icon={faUserGroup} size="sm" />
          {mitarbeiterListe.length}
        </Badge>
      </PopoverTrigger>
      {mitarbeiterListe.length > 0 && (
        <PopoverContent className="p-0 w-full max-w-xs">
          <Command className="max-w-sm round-lg py-1 px-2">
            <CommandList className="p-0">
              {mitarbeiterListe.map((ma) => (
                <CommandItem
                  key={ma.id}
                  className="mx-0 p-2 data-[selected=true]:bg-transparent data-[selected=true]:text-neutrals-200">
                  <div className="flex gap-2 items-center">
                    <Avatar className="h-9 w-9">
                      <AvatarImage
                        src={ma.bildUrl ?? ''}
                        alt={`${ma.vorname} ${ma.nachname} `}
                      />
                      <AvatarFallback>
                        <FontAwesomeIcon
                          icon={faUser}
                          size="lg"></FontAwesomeIcon>
                      </AvatarFallback>
                    </Avatar>
                    <div className="flex flex-row">
                      <span className="text-neutrals-900 text-sm font-normal">
                        {ma.vorname} {ma.nachname}
                      </span>
                    </div>
                  </div>
                  <CommandSeparator />
                </CommandItem>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      )}
    </Popover>
  );
}
